@if (package$ | async; as package) {
	<div data-test-id="package-detail">
		<vp-carousel [items]="images" data-test-id="package-detail-carousel" />
		<section class="section-spacing bg-white">
			<div class="section-gap mx-auto max-w-screen-2xl">
				<div
					class="gap-content-section flex w-full flex-col md:mx-auto md:flex-row"
				>
					<div class="flex w-full flex-col gap-8 lg:w-1/2 xl:w-2/3">
						<div>
							<header>
								<h1
									class="heading-group heading-group-lg"
									data-test-id="room-detail-title"
								>
									{{ package.name }}
								</h1>
								<p
									class="heading-group-overline"
									role="doc-subtitle"
								>
									{{ 'global.package-label' | translate }}
								</p>
							</header>
						</div>
						<vp-read-more>
							<markdown
								[data]="package.description"
								data-test-id="package-detail-description"
							/>
						</vp-read-more>
						<h2
							class="running-head running-head-center"
							data-test-id="package-header"
						>
							@if (package.packages.length > 1) {
								{{
									'storyblok.pages.choose-your-package'
										| translate
								}}
							} @else {
								{{ 'storyblok.pages.your-package' | translate }}
							}
						</h2>
						<div class="card card-lg flex flex-col gap-4">
							<p
								class="heading-group heading-group-sm font-semibold"
							>
								{{
									'storyblok.pages.package-includes'
										| translate
								}}
							</p>
							@if (package.packages.length > 1) {
								<markdown
									[data]="package.packages[0].bulletContent"
									class="list-checkmarks"
									data-test-id="package-detail-description"
								/>
							}
						</div>
						@if (package.hotel) {
							<h2
								class="running-head running-head-center"
								data-test-id="faq-header"
							>
								{{
									'storyblok.pages.hotel-information'
										| translate
								}}
							</h2>
							@if (package.hotel.images?.length > 0) {
								<vp-image
									[image]="{
										src: package.hotel.images[0].src,
										altText: package.hotel.images[0].alt,
										width: 900,
										height: 386,
									}"
									[sources]="[
										{
											min: null,
											max: sizes.md,
											width: 624,
											height: 351,
										},
										{
											min: sizes.md,
											max: null,
											width: 900,
											height: 386,
										},
									]"
									className="aspect-video w-full rounded-sm lg:aspect-anamorphic"
								/>
							}
							<vp-tab-menu>
								<vp-tab-menu-item
									[content]="facilitiesRef"
									[label]="'global.facilities' | translate"
									name="facilities"
								/>
								<vp-tab-menu-item
									[content]="goodToKnowsRef"
									[label]="'global.good-to-know' | translate"
									name="good-to-knows"
								/>
							</vp-tab-menu>
							<ng-template #facilitiesRef>
								<ng-container
									[ngTemplateOutlet]="list"
									[ngTemplateOutletContext]="{
										listItems:
											package.hotel?.facilities || [],
										grid: true,
										name: 'facilities',
									}"
								/>
							</ng-template>
							<ng-template #goodToKnowsRef>
								<ng-container
									[ngTemplateOutlet]="list"
									[ngTemplateOutletContext]="{
										listItems:
											package.hotel?.goodToKnows || [],
										grid: false,
										name: 'good-to-knows',
									}"
								/>
							</ng-template>
						}
						<h2
							class="running-head running-head-center"
							data-test-id="faq-header"
						>
							{{ 'storyblok.pages.faq-title' | translate }}
						</h2>
						<div
							class="flex flex-col gap-4"
							data-test-id="package-faqs"
						>
							@if (package.packages.length > 0) {
								<vp-accordion
									[isOpen]="true"
									[title]="
										'storyblok.pages.package-terms-and-conditions'
											| translate
									"
									data-test-id="accordion-faq"
								>
									<markdown
										[data]="
											package.packages[0]
												.termsAndConditions
										"
									/>
								</vp-accordion>
							}
							@for (faq of package.faqs; track $index) {
								<vp-accordion
									[title]="faq.question"
									data-test-id="accordion-faq"
								>
									<markdown [data]="faq.answer" />
								</vp-accordion>
							}
						</div>
					</div>
					<div class="w-full lg:w-1/2 xl:w-1/3">
						<div class="card card-lg flex flex-col gap-4">
							<vp-pricing
								[conditions]="
									'components.pricing.per-person-per-night'
										| translate
								"
								[currency]="package.price.currency"
								[isHorizontal]="true"
								[price]="package.price.amount"
								size="lg"
							/>
							<vp-package-details
								[package]="{
									title: package.name,
									variation: package.packages[0].name,
								}"
								className="hidden lg:block"
							/>
							<a
								[href]="
									this.bookingtool +
									this.hotelSlug +
									'?packageGUID=' +
									package.packages[0].GUID
								"
								class="btn btn-primary w-full"
							>
								{{
									'storyblok.pages.package.button-cta'
										| translate
								}}
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
}

<ng-template #list let-grid="grid" let-listItems="listItems" let-name="name">
	<div
		[id]="name"
		class="list-checkmarks list-grid flex flex-col gap-4 md:gap-8"
	>
		<ul
			[ngClass]="{ 'sm:grid-cols-3': grid }"
			class="grid grid-cols-1 gap-4"
		>
			@for (item of listItems; track item) {
				<li>{{ item }}</li>
			}
		</ul>
	</div>
</ng-template>
